const HandlePaginateService = {

  /**
  * 
  * Handle pagination for list or search.
  *
  * @param {number} page - The page number to fetch.
  * @param {boolean} isSearch - Whether currently in search mode.
  * @param {Function} searchFn - Function to call for search pagination.
  * @param {Function} listFn - Function to call for list pagination.
   */
  paginate({ page, isSearch, searchFn, listFn }) {
    if (isSearch) {
      searchFn(page);
    } else {
      listFn(page);
    }
  },

  /**
   * Handle pagination after delete action.
   *
   * @param {Object} options
   * @param {Object} options.listData
   * @param {number} options.currentPage
   * @param {boolean} options.isSearch
   * @param {Function} options.searchFn
   * @param {Function} options.listFn
   */
  afterDelete({ listData, currentPage, isSearch, searchFn, listFn }) {
    let targetPage = currentPage;
    if (listData?.data?.length === 1 && currentPage > 1) {
      targetPage = currentPage - 1;
    }

    if (isSearch) {
      searchFn(targetPage);
    } else {
      listFn(targetPage);
    }
  },
}
export default HandlePaginateService;
